import styled from 'styled-components';
import { mixins, media } from '../../../css';

export const ResponsiveWrapper = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: center;
  flex-direction: column-reverse;

  ${media.greaterThan('md')`
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
  `};
`;
export const FlexWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  /* keeps height consistant when hiding buttons */
  min-height: 64px;
`;

export const ButtonWrapper = styled.div`
  margin-top: ${mixins.pxToRem(16)};
  display: flex;
  align-items: center;
  margin-left: ${mixins.pxToRem(20)};
`;

export const SelectWrapper = styled.div`
  margin-left: ${mixins.pxToRem(20)};
  text-align: right;
`;

export const CopyWrapper = styled.div`
  margin-top: ${mixins.pxToRem(16)};
  margin-left: ${(props) => (props.count > 1000 ? `${mixins.pxToRem(8)}` : `${mixins.pxToRem(20)}`)};
`;

export const StyledButton = styled.button`
  color: rgba(0, 0, 0, 0.54);
  padding: 12px;
  overflow: visible;
  text-align: center;
  border-radius: 50%;
  height: 48px;
  width: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;
  background-color: rgba(0, 0, 0, 0);
  background-position: center;
  transition: background 0.6s;

  cursor: pointer;
  * {
    cursor: pointer;
  }

  &:not(:disabled):hover {
    background: #ebebeb radial-gradient(circle, transparent 1%, #cacaca 1%) center/15000%;
  }
  &:not(:disabled):active {
    transition: background 0s;
    background-color: #cacaca;
    background-size: 100%;
  }
`;
